import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { PassingModeRepository } from '@/store/passing-mode-state/passing-mode-state.repository';
import { PassingModeDto, passingModeStep, passingModeType } from '@/types';
import { passingModeStepLabels, passingModeTypeLabels } from '@/pages/settings/passing-mode/utils/type-labels';

interface IgetPassingModeDataTableStructureProps {
  store: PassingModeRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
  enableServerActions?: boolean;
  marketTypesOptions?: SelectOption[];
}

export const getpassingModeDataTableStructure = ({
  store,
  createAction,
  rowActions,
  serverQuery,
  enableServerActions,
  marketTypesOptions,
}: IgetPassingModeDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.passingMode.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const labelColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.passingMode.table.label',
    accessorKey: 'libelle',
    variant: DataTableColumnVariant.TEXT,
  };

  const restraintColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'settings.passingMode.table.restraint.label',
    accessorKey: 'restraint',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return {
        value: `settings.passingMode.table.restraint.${value}`,
      };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'success' : 'danger';
      },
    },
  };
  const typeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.passingMode.table.type',
    accessorKey: 'type',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: any): any => {
      const humanized =
        typeof value === 'string' && value in passingModeTypeLabels ? passingModeTypeLabels[value as passingModeType] : String(value ?? '');

      return { value: humanized };
    },
  };
  const etapesColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.passingMode.table.etapes',
    accessorKey: 'etapes',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: any): any => {
      const humanized =
        typeof value === 'string' && value in passingModeStepLabels ? passingModeStepLabels[value as passingModeStep] : String(value ?? '');

      return { value: humanized };
    },
  };

  return {
    singular: 'settings.passingMode.table.singular',
    plural: 'settings.passingMode.table.plural',
    columns: [idColumn, labelColumn, restraintColumn, typeColumn, etapesColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('response', row);
      const dto: PassingModeDto = {
        libelle: row.libelle,
        restraint: row.restraint,
        type: row.type,
        etapes: row.etapes,
        typeMarchersIds: row.typeMarchersIds,
      };
      store.set('dto', dto);
      store.set(
        'typeMarchersSelected',
        marketTypesOptions?.find(option => option.code === row.id)
      );
    },
    createAction,
    rowActions,
    serverQuery,
    enableServerActions,
    searchableFields: ['libelle', 'restraint'],
  };
};
